export class OperatorSummary {
  id: string = '';
  fullName?: string = '';
  personModelId?: string = '';
}
